import { FC } from 'react'
import { Show, useRecordContext, useRefresh } from 'react-admin'
import { PrognoseSetResponse } from '../../types/apiRequests'
import { PrognoseShowView } from '../../components/prognose'

const StadsprognoseShowContent: FC = () => {
  const record = useRecordContext<PrognoseSetResponse>()
  const refresh = useRefresh()

  return (
    <PrognoseShowView
      record={record ?? null}
      loading={!record}
      subtitle={record ? `Stadsprognose | Periode: ${record.bjaar} - ${record.ejaar}` : undefined}
      onRefetch={refresh}
    />
  )
}

const StadsprognoseShow: FC = () => (
  <Show>
    <StadsprognoseShowContent />
  </Show>
)

export default StadsprognoseShow
